import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook to handle smooth scrolling to hash anchors
 * Scrolls to element with ID matching the URL hash when page loads or hash changes
 * Works seamlessly with React Router SPA navigation
 */
export const useScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    // Get hash from URL (e.g., "#branding" from "/services#branding")
    const hash = location.hash.slice(1); // Remove the # character

    if (hash) {
      // Wait a bit for the DOM to be ready, especially after navigation
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(hash);

        if (element) {
          // Scroll to the element with smooth behavior
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    } else {
      // No hash, scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);
};
